import { IAddressViewModel } from "./I4UViewModels";

export class AddressFormat {
    public static toSingleString(
        address: IAddressViewModel,
        options?: {
            country?: boolean,
            coName?: boolean
        }) {
        if (address == null)
            return "";

        let str = "";
        let commaNext = false;
        let rowChange = false;

        if (options && options.coName) {
            if (address.COName) {
                if (str)
                    str += commaNext ? ", " : " ";
                str += address.COName;
                rowChange = true;
            }
        }

        if (address.Street) {
            if (str) {
                if (rowChange)
                    str += "\r\n";
                else
                    str += commaNext ? ", " : " ";
            }
            str += address.Street;
            commaNext = true;
            rowChange = false;
        }

        if (address.Zip) {
            if (str)
                str += ", ";
            str += address.Zip;
            commaNext = false;
        }
        if (address.Place) {
            if (str)
                str += commaNext ? ", " : " ";
            str += address.Place;
            commaNext = false;
        }

        if (options && options.country) {
            if (address.Country) {
                if (str)
                    str += commaNext ? ", " : " ";
                str += address.Country;
            }
        }

        return str;
    }
}